import { render, staticRenderFns } from "./legal_female.vue?vue&type=template&id=de7d842a&scoped=true&"
var script = {}
import style0 from "./legal_female.vue?vue&type=style&index=0&id=de7d842a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de7d842a",
  null
  
)

export default component.exports